/**
 * This file is one big doc ready
 * DON'T PUT ANYTHING ELSE IN HERE ON PAIN OF DEATH. YOU HAVE BEEN WARNED
 */
$(document).ready(function() {

    /**
     * Disable submit button on applciation
     * creation screen as it was submitting twice
     *
     * @type {boolean}
     */
    var submitted = false;
    var submitButton = $('.form-buttons button[type=submit]');

    submitButton.on('click', function(e) {
        if (submitted)
        {
            e.preventDefault();
            return false;
        }

        submitted = true;
    });

    /**
     * Disable Send button to prevent sending twice after submit
     *
     * @type {boolean}
     */

    //mutiple buttons with action name so need to sort by value for send
    var buttons = document.getElementsByName("action");
    var sendButton = "";
    var sent = false;

    buttons.forEach(isSend);

    function isSend(button)
    {
        if(button.value == "send")
        {
            sendButton = button;
        }
    }
 
    if(sendButton !== "")
    {
        sendButton.onclick = function(e)
        {
            if(sent)
            {
                e.preventDefault();
                return false;
            }
            sendButton.innerHTML = "Processing...";
            sent = true;
        };
        
    }
     
    //Setup a CSRF token for all ajax requests
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        cache: false,
        timeout: 5000
    });

    /**
     * Initialize bootstrap popovers - elements with data-toggle=popover - will have popover events bound to them
     */
    // $('[data-toggle="popover"]').popover();
    $('[data-toggle="tooltip"]').tooltip();

    /**
     * Initialise all on-page save buttons and submitters
     */
    $('[data-role="on-page-save"]').onPageSave();

    $('[data-role="disabled"]').on('click', function(e){
        e.preventDefault();
    });

    /**
     * Initialise bootstrap friendly File Fields
     */
    $('.btn-file :file').bootstrapFileSelector();

    /**
     * Initialise password field reveals
     */
    $('[data-role="password-flipper"]').passwordFlipper();

    /**
     * Initialise unlockable field toggles
     */
    $('[data-role="field-unlocker"]').fieldUnlocker();

    /**
     * Initialise inline content editors
     */
    $('[data-role="inline-content-editor"]').inlineContentEditor();

    /**
     * Initialise select filters
     */
    $("[data-role='select-filter']").selectFilter();


    //catch validation tooltips but remove them when field receives focus
    $('[data-validation-tooltip="1"]').tooltip('show').on("focus", function(e) {
        $(this).tooltip("destroy");
    });

    /************T&C**************/

    var removeAllTinyMCEInstances = function() {
        if(typeof(tinymce) !== 'undefined') {
            var length = tinymce.editors.length;
            for (var i=length; i>0; i--) {
                tinymce.editors[i-1].remove();
            }
        }
    };

    var closeAnyOpen = function() {
        $('[data-open]').remove();
        $('[data-save="true"]').attr({'data-save':false, 'data-edit':true, 'data-original-title': 'Edit'}).removeClass('btn-success').addClass('btn-primary').find('.button-text').text('Edit');       
        $('[data-edit="true"]').find('i').removeClass('fa-save').addClass('fa-pencil');

        removeAllTinyMCEInstances();
    };

    var editTerms = function(e) {
        e.preventDefault();
        closeAnyOpen();

        var $this = $(this);
        var parentTr = $this.closest('tr');
        var newTr = $('<tr data-open="true">').insertAfter(parentTr);
        $this.tooltip('hide');

        $.get('/terms-and-conditions/'+$this.data('id')+'/edit', function(r) {
            newTr.append('<td colspan="5">' + r + '</td>');
            $this.attr({'data-save':true, 'data-edit':false, 'data-original-title': 'Save'}).removeClass('btn-primary').addClass('btn-success').find('.button-text').text('Save');
            $this.find('i').removeClass('fa-pencil').addClass('fa-save');
            $.ladda('stopAll');
            tinymce.init({
                selector: "#content"+$this.data('id'),
                plugins: ["autoresize", "code", "lists", "link"],
                menubar: 'edit insert format tools'
            });
            tinymce.init({
                selector: "#welsh-content"+$this.data('id'),
                plugins: ["autoresize", "code", "lists", "link"],
                menubar: 'edit insert format tools'
            });
        });
    };

    var saveTerms = function(e) {
        e.preventDefault();

        tinymce.triggerSave();

        var $this = $(this);
        var parentTr = $this.closest('tr');
        var id = $this.data('id');
        var form = $('[data-open]').find('form');
        var formData = form.serialize();
        $this.tooltip('hide');
        $.ajax({
            method : 'POST',
            url : '/terms-and-conditions/'+id,
            data : formData,
            dataType: 'json',
            success : function(r) {
                closeAnyOpen();
                $.ladda('stopAll');
                $this.attr({'data-save':false, 'data-edit':true, 'data-original-title': 'Edit'}).removeClass('btn-success').addClass('btn-primary').find('.button-text').text('Edit');
                $this.find('i').removeClass('fa-save').addClass('fa-pencil');
                tinymce.execCommand('mceRemoveControl', true, 'content'+id);
                //console.log(r.updated_at);
                parentTr.find('.updated-at').html(r.updated_at);
            }
        });
    };

    $('.ladda-button').ladda( 'bind' );
    $('body').on('click', 'a[data-edit="true"]', editTerms);
    $('body').on('click', 'a[data-save="true"]', saveTerms);

    /************T&C**************/

    /************User Permissions**************/

    var $inputs = $('input[data-left]');

    $('ul ul').hide();
    $('ul li').click(function(){
        var $li = this;
        if($(this).next().is("ul")) {
            $(this).next().slideToggle();

            if ($('strong', $li).text() === '+') {
                $('strong', $li).text('-');
            } else {
                $('strong', $li).text('+');
            }
        }
    });

    $inputs.change(function() {

        var $left = $(this).data('left');
        var $right = $(this).data('right');

        if ($(this).prop('checked')) {
            $inputs.each(function() {
                if ($(this).data('left') <= $left && $(this).data('right') >= $right) {
                    $(this).prop('checked', true);
                }
            });
        } else {
            $inputs.each(function() {
                if ($(this).data('left') > $left && $(this).data('right') < $right) {
                    $(this).prop('checked', false);
                }
            });
        }
    });

    /************User Permissions**************/

    /************Delete Confirmation**************/

    $('[data-role="delete-confirmation"]').on('click', function(e){
        e.preventDefault();
    });

    $('#confirm-delete').on('show.bs.modal', function(e){

        var $this = $(this);
        var $message = $(e.relatedTarget).attr('data-message');
        var $title = $(e.relatedTarget).attr('data-title');
        var form = $(e.relatedTarget).closest('form');

        $this.find('.modal-body p').html($message);
        $this.find('.modal-title strong').text($title);
        $this.find('.modal-footer #confirm').data('form', form);

    });

    $('#confirm-delete').find('.modal-footer #confirm').on('click', function(){
        $(this).data('form').submit();
    });

    /************Delete Confirmation**************/

    /**
     * ConfigItems
     */
    // $('[data-role="config-item-editor"]').configItemEditor();


    /**
     * Dirty forms
     *
     * To apply dirty form checking with an exit confirmation to forms,
     * the form must have a data-dirty attribute. Value does not matter.
     * The only caveat to this system is that the exit without saving check
     * only binds to <a> tags and not window.location or any other method
     * of changing the page.
     */
    (function() {

        var $dirtyForms = $('form[data-dirty]');
        var $linkTarget;
        var $modal = $('#modal-exit-confirmation');

        $dirtyForms.dirty();

        $('.confirm', $modal).click(function() {
            $dirtyForms.dirty('reset');
            $modal.modal('hide');

            if ($linkTarget) {
                $linkTarget.click();
                $linkTarget = null;
            }
        });

        $('.deny', $modal).click(function() {
            $modal.modal('hide');
        });

        $('body').on('click', 'a:not([data-role="nav-toggle"], [id="content-skip"], [data-toggle-hide], [data-modal], [target="_blank"], [prevent-dirty])', function($event) {

            var $notDirty = true;
            $dirtyForms.each(function() {
                $notDirty &= !$(this).dirty('check');
            });
            $linkTarget = this;

            if (!$notDirty) {
                $event.preventDefault();
                $modal.modal('show');
            }
        });

    })();

    $('body').on('submit', 'form[data-warn]', function(e)
    {
        var $this = $(this);
        var $selector = $this.data('warn');
        var $message = $this.data('warn-message');
        var $field = $($selector, $this);

        if ($this.data('no-warning') || $field.length < 1 || $field.val())
        {
            return true;
        }

        var $modal = $('[data-role="warn"]');
        $modal.find('.modal-body').html($message);
        $modal.off('click', 'button[data-action]');
        $modal.on('click', 'button[data-action]', function(e) {

            switch ($(this).data('action'))
            {
                case 'continue':
                    $this.data('no-warning', true);
                    $this.trigger('submit');
                    break;

                case 'cancel':
                    $modal.modal('hide');
                    break;
            }

        });

        $modal.modal('show');

        return false;
    });

    $('[data-role="add-record"]').addRecord();
    $('[data-role="editable-row"]').editRecord();

    /** TEMPORARY **/
    $(document).ready(function()
    {
        $('[data-password-viewer]').each(function()
        {
            var $field = $('#' + $(this).data('password-viewer'));

            if ($field.length)
            {
                $(this).hover(function()
                {
                    $field.attr('type', 'text');
                }, function()
                {
                    $field.attr('type', 'password');
                });
            }
        });
    });


    /**
     * Pass phrase generator
     *
     * To use this method, add a data-generate-phrase attribute to a button
     * and put an input field's id as the attribute.
     */
    $('[data-generate-phrase]').click(function() {
        var $field = $($(this).data('generate-phrase'));
        if (!$field.prop('disabled') && !$field.prop('readonly') && $field.is(':visible')) {
            $field.val(generateDbsPhrase()).trigger('keyup');
        }
    });


    /**
     * Unique username generator
     */
    $('[data-generate-username]').click(function() {
        var $this = $(this);
        var $field = $($this.data('generate-username'));
        var usernameFeedback = $('.username-feedback');

        if ($field.prop('disabled') || $field.prop('readonly') || !$field.is(':visible')) {
            return false;
        }


        function myTrim(x) {
            return x.replace(/^\s+|\s+$/gm,'');
        }

        var name = {
            forename : myTrim($('[name*="forename"]').val()),
            surname : myTrim($('[name*="surname"]').val())
        };
        name['forename'] = myTrim(name['forename']);
        name['surname'] = myTrim(name['surname']);

        delay(function() {
            $.ajax({
                url: '/generate-unique-username',
                type: 'post',
                data: name,
                dataType: 'json',
                success: function (json) {
                    if (json.status) {
                        usernameFeedback.addClass('hidden');
                        return $field.val(json.username);
                    }

                    usernameFeedback.removeClass('hidden').find('span.message').text(json.error);
                }
            });
        }, 500);
    });

    $('[name="username"]').on('keyup', function()
    {
        var $this = $(this);
        
        delay(function(){
            var username = $this.val();
            var usernameFeedback = $('.username-feedback');

            $.ajax({
                url: '/is-username-available',
                type: 'post',
                data: {'username' : username},
                dataType: 'json',
                success: function(json) {

                    if ( ! json.usernameAvailable )
                    {
                        return usernameFeedback.removeClass('hidden').find('span.message').text(json.error);
                    }

                    usernameFeedback.addClass("hidden");
                    // if ( ! json.usernameAvailable)
                    // {
                    //     if(!usernameFeedback.is(':visible'))
                    //     {
                    //         usernameFeedback.removeClass('hidden');
                    //     }
                    // }
                    // else
                    // {
                    //     if(usernameFeedback.is(':visible'))
                    //     {
                    //         usernameFeedback.addClass('hidden');
                    //     }
                    // }
                }
            });

        }, 500);
    });

    var delay = (function(){
        var timer = 0;
        return function(callback, ms){
            clearTimeout (timer);
            timer = setTimeout(callback, ms);
        };
    })();


    /**
     * Data value binder
     */
    $('[data-bind-value]').on('change keyup keydown', function() {

        var attr = $(this).attr('data-bind-text');

        if (typeof attr !== typeof undefined && attr !== false)
        {
            $($(this).data('bind-value')).val($(this).text());
        }
        else
        {
            $($(this).data('bind-value')).val($(this).val());
        }
    });


    /**
     * Password meter binder
     */
    var $passwordMeterInputs = $('input[data-password-meter]');

    if ($passwordMeterInputs.length > 0)
    {
        var $password = new Password;
    }

    $passwordMeterInputs.each(function() {

        var $passwordMeter = $('<div class="password-meter empty fail">')
            .append('<div class="indicator">')
            .append('<div class="section fail" data-min="0" data-length="20">')
            .append('<div class="section bad" data-min="20" data-length="10">')
            .append('<div class="section good" data-min="30" data-length="10">')
            .append('<div class="section great" data-min="40" data-length="20">')
            .append('<div class="section excellent" data-min="60" data-length="40">');

        var $inputGroup = $(this).parents('.input-group');

        if ($inputGroup.length)
        {
            $passwordMeter.insertAfter($inputGroup);
        }
        else
        {
            $passwordMeter.insertAfter($(this));
        }

        var $sections = $passwordMeter.find('.section');
        var $indicator = $passwordMeter.find('.indicator');
        var $password = new Password;

        $(this).on('keydown keyup', function() {

            var $strength = $password.check($(this).val());
            var $textPassword = $(this).val();

            var $chosen = null;
            var $sectionNumber = 0;
            var $chosenSection = 0;


            $sections.each(function() {
                if ($strength >= $(this).data('min'))
                {
                    $chosen = this;
                    $chosenSection = $sectionNumber;
                }
                $sectionNumber++;
            });

            var $totalPercentage = 0;

            if ($chosen)
            {
                var $sectionPercentage = (($strength - $($chosen).data('min')) / $($chosen).data('length') * 100) / 5;
                $totalPercentage = ($chosenSection * 20) + $sectionPercentage;
            }

            if ($totalPercentage > 100)
            {
                $totalPercentage = 100;
            }

            if ($textPassword.length < 1)
            {
                $passwordMeter.addClass('empty');
            }
            else
            {
                $passwordMeter.removeClass('empty');
            }

            if ($totalPercentage <= 0)
            {
                $indicator.css({
                    opacity:0,
                    right:'100%'
                });

                $passwordMeter.addClass('fail');
            }
            else
            {
                $passwordMeter.removeClass('fail');
                $indicator.css({
                    opacity: 1,
                    right: (100 - $totalPercentage) + '%'
                });
            }
        });

    })

    $('[data-role="copy-to-org"]').copyToOrg();

    $('.datepicker').each(function() {

        var $format = $(this).data('date-format');
        var $view = $(this).data('date-view');
        var $maxDate = undefined===$(this).data('date-max-date') ? new Date() : new Date($(this).data('date-max-date'));

        if (!$format.length)
        {
            $format = 'DD/MM/YYYY';
        }

        $('input', this).datepicker({
            format : $format,
            viewMode: $view,
            maxDate : $maxDate
        }).on('change', function(){
            if (this.validate) {
                this.validate();
            }
            return true;
        });
    });


    $('[data-selectize]').selectize({
        dropdownDirection: 'auto'
    });


    /**
     * Generic modals
     */
    $(document).on('click', '[data-modal]', function(e) {

        e.preventDefault();

        $(this).tooltip('hide'); 

        if (this !== e.target && $(e.target).is('[data-modal]'))
        {
            return;
        }

        $($(this).data('modal')).modal({
            show: true,
            backdrop: $(this).is('[data-modal-static]') ? 'static' : true
        });
    });

    $(document).on('click', '[data-modal-close]', function() {
        $($(this).data('modal-close')).modal('hide');
    });

    $('form[data-ajax]').submit(function(e) {
        e.preventDefault();
        var $form = $(this);
        $form.find('.has-error').removeClass('has-error has-warning');
        $form.find('[data-toggle="tooltip"]').tooltip('destroy');

        $.ajax({
            url: $form.attr('action'),
            type: 'post',
            data: $form.serializeArray(),
            dataType: 'json',
            success: function(json)
            {
                if (!json.success)
                {
                    for (var x in json.errors)
                    {
                        var $field = $('[name="' + x + '"]', $form);
                        $field.parents('.form-group').addClass('has-error');

                        var $parent = $field.parents('.form-group');

                        $parent.find('[data-toggle="tooltip"]').tooltip();
                    }
                }

                if ($('tr.editing').length) {
                    $('tr.editing').find('td:eq(1)').text(json.data.label);
                    $('button[data-role="edit"]', $('tr.editing')).data('value', json.data.label);
                }

                $form.parents('.modal').modal('hide');
            }
        })
    });

    $('#modal-address [data-action="submit"]').click(function() {
        var $form = $('#modal-address form');
        $form.find('.has-error').removeClass('has-error');
        $form.find('[data-toggle="tooltip"]').tooltip('destroy');
        var $previousAddressErrors = $('#previous-address-errors');

        $previousAddressErrors.css('display', 'none');

        $.ajax({
            url: $form.attr('action'),
            type: 'post',
            data: $form.serializeArray(),
            dataType: 'json',
            success: function(json)
            {
                if (!json.success)
                {
                    $previousAddressErrors.css('display', 'block');
                    $previousAddressErrors.html('');
                    for (var x in json.errors)
                    {
                        var $field = $('[name="address[' + x + ']"]', $form);
                        $field.parents('.form-group').addClass('has-error');

                        var $parent = $field.parents('.form-group');

                        $parent.find('[data-toggle="tooltip"]').tooltip();
                        var messages = json.errors[x];
                        for(var i = 0; i < messages.length; i++) {
                            $previousAddressErrors.append('<p>'+messages[i]+'</p>');
                        }
                    }
                    return;
                }

                var $previousAddresses = $('#previous-addresses tbody');

                $('tr[data-address-id="' + json.id + '"]').remove();
                var deleteBtn = "";

                if (!JSON.parse(json.current))
                {
                    deleteBtn = $('<a>')
                        .addClass('btn btn-xs btn-danger')
                        .attr('data-delete-address', json.hash)
                        .html('<span class="fa fa-trash"></span>')
                }
                if (document.location.href.indexOf('basic') > -1){
                    $previousAddresses.append(
                        $('<tr>')
                            .attr('data-timestamp', json.timestamp)
                            .attr('data-address-id', json.id)
                            .append(
                                $('<td>').text(json.shortHand),
                                json.current
                                    ? $('<td><span class="label label-success">current</span></td>')
                                    : $('<td><span class="label label-info">previous</span></td>'),
                                $('<td>').text(json.from).attr('data-name', 'from'),
                                $('<td>').text(json.until).attr('data-name', 'until'),
                                $('<td class="table-cell-wrap">')
                                    .append(
                                        $('<a>')
                                            .addClass('btn btn-xs btn-warning')
                                            .attr('data-edit-address', json.id)
                                            .attr('data-modal', '#modal-address')
                                            .attr('data-modal-static', true)
                                            .html('<span class="fa fa-pencil"></span>'),
                                        ' ',
                                        deleteBtn
                                    )
                            )
                    );
                } else {
                    $previousAddresses.append(
                        $('<tr>')
                            .attr('data-timestamp', json.timestamp)
                            .attr('data-address-id', json.id)
                            .append(
                                $('<td>').text(json.shortHand),
                                $('<td>').text(json.from + ' - ' + json.until).addClass('visible-xs'),
                                json.current
                                    ? $('<td><span class="label label-success">current</span></td>')
                                    : $('<td><span class="label label-info">previous</span></td>'),
                                $('<td>').text(json.from).attr('data-name', 'from').addClass('hidden-xs'),
                                $('<td>').text(json.until).attr('data-name', 'until').addClass('hidden-xs'),
                                $('<td>')
                                    .addClass('table-cell-wrap')
                                    .append(
                                        $('<a>')
                                            .addClass('btn btn-xs btn-warning')
                                            .attr('data-edit-address', json.id)
                                            .attr('data-modal', '#modal-address')
                                            .attr('data-modal-static', true)
                                            .html('<span class="fa fa-pencil"></span>'),
                                        ' ',
                                        deleteBtn
                                    )
                            )
                    );
                }
                $('[data-role="no-previous-addresses"]').addClass('hidden');

                $('#modal-address').modal('hide');

                $('#previous-addresses tbody tr')
                    .sort(function(a, b) { return $(a).data('timestamp') < $(b).data('timestamp'); })
                    .appendTo('#previous-addresses tbody');

                var $addresses = new Addresses();
                $addresses.updateAddressHistoryStatistics();
            }
        });
    });

    $(document).on('click', '[data-edit-address]', function()
    {
        $('#modal-address .modal-title').text('Manage Address');

        var $addresses = new Addresses();
        $addresses.loadPreviousAddress($(this).data('edit-address'));

        addressPreview =  document.getElementById('addressPreview');
        //if addressPreview is null, postcode lookup would not be enabled - saves using an ajax function to get tenant option.
        if(addressPreview != null)
        {
            addressFields  =  document.getElementById("addressData");
            showAddress    =  document.getElementById("showAddress");
            lookupGroup    =  document.getElementById('lookupGroup');

            addressFields.removeAttribute("hidden");
            showAddress.style.display = "none";
            lookupGroup.setAttribute("hidden","hidden");
            addressPreview.setAttribute("hidden","hidden");
            addressPreview.innerHTML = "";
        }
        
    });

    $(document).on('click', '[data-add-address]', function()
    {
        $('#modal-address .modal-title').text('Add Address');

        var $addresses = new Addresses();
        $addresses.loadNewAddress();

        addressPreview =  document.getElementById('addressPreview');
        //if addressPreview is null, postcode lookup would not be enabled - saves using an ajax function to get tenant option.
        if(addressPreview != null)
        {
            IdealPostcodes.PostcodeLookup.controllers.forEach(c => c.removeAll());
            addressFields  =  document.getElementById("addressData");
            showAddress    =  document.getElementById("showAddress");
            postcodeInput  =  document.getElementById('inputPostcode');

            addressFields.setAttribute("hidden","hidden");
            showAddress.style.display = "";
            showAddress.innerHTML = "Enter address manually"

            postcodeInput.disabled = false;
            buttonPostcode = document.getElementById('buttonPostcode');
            buttonPostcode.removeAttribute("disabled");

            lookupGroup    =  document.getElementById('lookupGroup');
            lookupGroup.removeAttribute("hidden");

            loadPostcodeLookup(addressFields, showAddress, addressPreview, postcodeInput);
        }
    });

    $(document).on('click', '[data-delete-address]', function() {

        var $addresses = new Addresses();
        $addresses.deleteAddress($(this).data('delete-address'), $(this).parents('tr'));
    });

    var loadPostcodeLookup = function(addressFields, showAddress, addressPreview, postcodeInput)
    {
        apiKey = '';
    
        if(window.JS_APP_ENV == 'production')
        {
            //prod api key
            apiKey  = 'ak_kqtfbpgkjaNFFS0WZFM9bWoFGz26u';
        }
        else
        {
            //dev api key
            apiKey   = 'ak_ko1hvmozdzhmdo5bnmaYsLWMFtWTk';
        }

        addressPreview.setAttribute("hidden","hidden");
        addressPreview.innerHTML = "";

        IdealPostcodes.PostcodeLookup.setup({
            apiKey: apiKey,
            context: '#lookup_field',
            button: '#buttonPostcode',
            input: '#inputPostcode',
            selectClass: 'form-control',
            selectContainerId: 'idealSelect',
            outputFields:
            {
                sub_building_name: '[name="address[flat_number]"]',
                building_number: '[name="address[building_number]"]',
                dependant_locality: '[name="address[address_line_2]"]',
                building_name: '[name="address[building_name]"]',
                thoroughfare: '[name="address[street]"]',          
                post_town: '[name="address[town]"]',
                postcode: '[name="address[postcode]"]',
                county: '[name="address[county]"]',
                country: '[name="address[country]"]'
            },
            onAddressSelected: function(address)
            {       
                previewLine1 = address.sub_building_name + " " + address.building_name; 
                previewLine2 = address.building_number + " " + address.dependant_thoroughfare + " " + address.thoroughfare;

                //remove spaces added by the above if fields are empty.
                if(previewLine1 == " ")
                {
                    previewLine1 = "";
                }

                if(previewLine2 == "  ")
                {
                    previewLine2 = "";
                }

                //capitalise post town - runs through all words eg TUNBRIDGE WELLS to Tunbridge Wells
                postTown = address.post_town.toLowerCase();
                words = postTown.split(" ");

                for (let i = 0; i < words.length; i++) {
                    words[i] = words[i][0].toUpperCase() + words[i].substr(1);
                }

                postTown = words.join(" ");

                var result = [
                    previewLine1,
                    previewLine2,
                    address.dependant_locality,
                    postTown,
                    address.county,
                    address.postcode,
                ].filter(elem => elem !== '')
                .join("</br>").replace(".", "");


                if(address.thoroughfare == "")
                {
                    $('[name="address[street]"]').val($('[name="address[address_line_2]"]').val());
                    $('[name="address[address_line_2]"]').val("");
                }

                if(address.dependant_thoroughfare !== "")
                {
                    line1 = address.dependant_thoroughfare + " " + $('[name="address[street]"]').val();
                    $('[name="address[street]"]').val(line1);
                }

                //strip "." from fields
                $('[name="address[flat_number]"]').val($('[name="address[flat_number]"]').val().replace(".", ""));
                $('[name="address[building_number]"]').val($('[name="address[building_number]"]').val().replace(".", ""));
                $('[name="address[building_name]"]').val($('[name="address[building_name]"]').val().replace(".", ""));
                $('[name="address[street]"]').val($('[name="address[street]"]').val().replace(".", ""));
                $('[name="address[address_line_2]"]').val($('[name="address[address_line_2]"]').val().replace(".", ""));   
                $('[name="address[town]"]').val($('[name="address[town]"]').val().replace(".", ""));
                $('[name="address[county]"]').val($('[name="address[county]"]').val().replace(".", ""));

                showAddress.style.display = "";
                showAddress.innerHTML = "Not your address? Enter address manually"
                addressFields.setAttribute("hidden","hidden");
                addressPreview.innerHTML = result;
                addressPreview.removeAttribute("hidden");
                postcodeInput.disabled = true;
                document.getElementById('idealSelect').style.display = "none";
                },
                onButtonTrigger: function(e)
                {
                    buttonPostcode = document.getElementById('buttonPostcode');
                    buttonPostcode.setAttribute("disabled","disabled");
                }
        }); 
    }

    /**
     * Selectize on DBS forms
     */
    /*$('[name="applicant[middle_names]"]').selectize({
        delimiter: ',',
        persist: false,
        maxItems:3,
        create: function(input) {
            return {
                value: input,
                text: input
            }
        },
        createOnBlur: true
    });*/


    /**
     * Toggle referee entries for reference creation
     */
    //$('[name="applicant_provides_references"]').change(function() {
    //
    //    var $referee = $('[data-role="referee"]');
    //
    //    switch ($(this).val()) {
    //        case '0':
    //            $referee.slideDown();
    //            break;
    //
    //        case '1':
    //            $referee.slideUp();
    //            break;
    //    }
    //});


    $('#switchUserRole').change(function()
    {
        window.location = '/switch-role/' + $(this).val();
    });


    /**
     * Toggle togglable stuff
     */
    $(document).on('click', '[data-toggle]', function() {

        var $toggleMe = $('[data-togglable="' + $(this).data('toggle') + '"]');
        var $truth = parseInt($(this).val());

        if ($(this).is('[type="checkbox"]'))
        {
            $truth = $(this).is(':checked');
        }

        if ($toggleMe.is('tr')) {
            $(this).find('i.fa').toggleClass('fa-plus fa-minus');
            $toggleMe.toggle();
            return;
        }

        if ($truth)
        {
            $toggleMe.slideDown();
        }
        else
        {
            $toggleMe.slideUp();
        }

    });

    $(document).on('click', '[data-mass-toggle]', function() {
        var $open = $(this).data('open');
        if ($open !== true && $open !== false) {
            $open = true;
        }
        $(this).data('open', !$open);
        var $toggle = $('[data-togglable]');
        if ($open) {
            $toggle.show();
            $(this).find('i.fa').removeClass('fa-plus').addClass('fa-minus');
            $('[data-mass-togglable] i.fa').removeClass('fa-plus').addClass('fa-minus');
        } else {
            $toggle.hide();
            $(this).find('i.fa').addClass('fa-plus').removeClass('fa-minus');
            $('[data-mass-togglable] i.fa').addClass('fa-plus').removeClass('fa-minus');
        }
    });

    $('[data-check-toggle]').click(function() {
        $('[data-check-me="' + $(this).data('check-toggle') + '"]').prop('checked', $(this).prop('checked'));
    });

    $('#copy_to_manager').click(function() {

        var $idVerifier = $('select[name="id_verifier"] :selected');

        if (!$idVerifier.val())
        {
            return;
        }

        $('[name="manager[forename]"]').val($idVerifier.data('forename'));
        $('[name="manager[surname]"]').val($idVerifier.data('surname'));
        $('[name="manager[email]"]').val($idVerifier.data('email'));
    });

    function selector(tbody, type) {
        $.each(tbody.find('tr'), function() {
            var td = $(this).find('td').eq(1);
            td.find('input[type=checkbox]').prop('checked', type);
        });
    }

    $('[data-role="selectNone"]').on('click', function(e){
        e.preventDefault();
        var $this = $(this);
        var tbody = $this.closest('table').find('tbody');
        selector(tbody, false);
        $this.hide();
        $('[data-role="selectAll"]').show();
    });

    $('[data-role="selectAll"]').on('click', function(e){
        e.preventDefault();
        var $this = $(this);
        var tbody = $this.closest('table').find('tbody');
        selector(tbody, true);
        $this.hide();
        $('[data-role="selectNone"]').show();
    });

    var toggleNav = function() {
        // $('#navigation').toggle();
        $('#nav-toggle').toggleClass('col-sm-3 col-sm-1').toggleClass('toggleMinimised');
        $('#navigation').toggleClass('col-sm-3 col-sm-1').toggleClass('minimised');

        $('#main').toggleClass('col-sm-9 col-sm-11');
        $(window).trigger('resize');
    }

    $('[data-role="nav-toggle"]').on('click', function(e) {
        e.preventDefault();

        toggleNav();

        if (getCookie('displayNav') == 'false') {
            setCookie('displayNav', true, 1);
        } else {
            setCookie('displayNav', false, 1);
        }

    });

    $('#navigation select').on('focus', function(){
        $(this).closest('li').addClass('hovered');
    }).on('blur', function(){
        $(this).closest('li').removeClass('hovered');
    });

    // if (getCookie('displayNav') == 'true' && $__options.loggedIn) {
    //     toggleNav();
    // }

    /**
     * Basic Id Verification validation
     */
//     (function() {

//         if (!$('[data-page="basic-identification-verify"]').length)
//         {
//             return;
//         }

//         var $driver = {
//             names: JSON.parse($('#driver-names').val()),
//             surname: $('#driver-surname').val(),
//             dob: new Date($('#driver-dob').val()),
//             gender: $('#driver-gender').val()
//         };

//         var $licence = new UkDrivingLicence();

//         $licence.registerEvent('setNumber', function() {

//             var $group = $('#driving-licence-number').parents('.form-group');
//             if (this.isValid())
//             {
//                 if ($('.dl-errors').length)
//                 {
//                     $('.dl-errors').addClass('hidden');
//                 }
//                 $group.removeClass('has-error');
//                 Queue.addItem({
//                     type: 4,
//                     message: 'UK Driving licence number appears to be valid.'
//                 });
//             }
//             else
//             {

//                 if ($('.dl-errors').length)
//                 {
//                     $('.dl-errors #errors').html(this.getErrors().map(function(err, i) {
//                         return "<p>" + err + "</p>";
//                     }));

//                     $('.dl-errors').removeClass('hidden');
//                 }

//                 $group.addClass('has-error');
//                 Queue.addItem({
//                     type: 2,
//                     message: this.getErrors().join('<br>')
//                 });
//             }
//         });

//         $licence.setForenames($driver.names);
//         $licence.setSurname($driver.surname);
//         $licence.setDateOfBirth($driver.dob);
//         $licence.setGender($driver.gender);
//         $licence.setNumber($('input[name="passport[passport_number]"]').val());

//         var $basic = new BasicIdVerification();
//         var $nationalInsuranceNumber = new NationalInsuranceNumber();
//         var $nationalInsuranceNumberValidator = function($value) {
//             $nationalInsuranceNumber.setNino(
//                 $('[name="national_insurance_number[prefix]"]').val() +
//                 $('[name="national_insurance_number[number]"]').val() +
//                 $('[name="national_insurance_number[suffix]"]').val()
//             );
//             return $nationalInsuranceNumber.isValid();
//         };

//         var $sections = {
//             'identity[passport]': {
//                 'passport[passport_number]': {
//                     required: true,
//                     length: [5, 30]
//                 },
//                 'passport[passport_country]': {
//                     required: true,
//                     length: [2,2]
//                 }
//             },
//             'identity[driving_licence]': {
//                 'driving_licence[driving_licence_number]': {
//                     required: true,
//                     length: [10, 20],
//                     custom: function($value) {
//                         if ($('[name="driving_licence[driving_licence_country]"]').val() !== 'United Kingdom') {
//                             if ($('.dl-errors').length && ! $('.dl-errors').hasClass('hidden')) {
//                                 $('.dl-errors').addClass('hidden');
//                             }
//                             return true;
//                         }
//                         $licence.setNumber($value);
//                         //$licence.setSurname($('[data-license="surname"]').val());
//                         //$licence.setGender($('[data-license="gender"]').val());
//                         //
//                         //var $dob = $('[data-license="dob"]').val();
//                         //$dob = moment($dob, 'DD/MM/YYYY');
//                         //
//                         //$licence.setDateOfBirth($dob);
//                         var $valid = $licence.isValid();

//                         //console.log('Licence valid: ', $valid);
//                         //console.log($licence.getErrors());

//                         return $valid;
//                     }
//                 },
//                 'driving_licence[driving_licence_country]': {
//                     required: true,
//                     length: [2,2]
//                 }
//             },
//             'identity[national_id_card]': {
//                 'national_id_card[national_id_card_number]': {
//                     required: true,
//                     length: [5, 20]
//                 },
//                 'national_id_card[national_id_card_country]': {
//                     required: true,
//                     length: [2,2]
//                 }
//             },
//             'identity[national_entitlement_card]': {
//                 'national_entitlement_card[national_entitlement_card_number]': {
//                     required: true,
//                     length: [16,16]
//                 }
//             },
//             'identity[pvg_scheme]': {
//                 'pvg_scheme[pvg_scheme_number]': {
//                     required: true,
//                     length: [16,16]
//                 }
//             },
//             'identity[electricity_supplier_number]': {
//                 'electricity_supplier_number[electricity_supplier_number]': {
//                     required: true,
//                     length: [21,21]
//                 }
//             },
//             'identity[national_insurance_number]': {
//                 'national_insurance_number[prefix]': {
//                     required: true,
//                     length: [2,2],
//                     custom: $nationalInsuranceNumberValidator
//                 },
//                 'national_insurance_number[number]': {
//                     required: true,
//                     length: [6,6],
//                     custom: $nationalInsuranceNumberValidator
//                 },
//                 'national_insurance_number[suffix]': {
//                     required: true,
//                     length: [1,1],
//                     custom: $nationalInsuranceNumberValidator
//                 }
//             },
//             'identity[other]': {
//                 'other[other_type_id]': {
//                     required: true
//                 },
//                 'other[other_details]': {
//                     required: true
//                 }
//             }
//         };

//         for (var x in $sections) {
//             var $section = $sections[x];
//             for (var y in $section) {
//                 $('[name="' + y + '"]').on('change keyup', function() {
//                     $basic.triggerValidation();
//                 });
//             }
//             $('[name="' + x + '"]').on('change', function() {
//                 $basic.triggerValidation();
//             });
//         }

//         $basic.registerEvent(['setDocuments', 'triggerValidation'/*, 'hasCurrentAddressInDocuments', 'hasConfirmation'*/], function() {

//             if (!$licence.isValid()) {
// //                return;
//             }

//             var $valid = true;

//             for (var x in $sections) {
//                 if ($('[name="' + x + '"]:checked').val() !== '1') {
//                     continue;
//                 }
//                 //console.log('Validating section: ', x);
//                 var $section = $sections[x];
//                 for (var y in $section) {
//                     var $field = $('[name="' + y + '"]');
//                     var $value = $field.val();
//                     var $group = $field.parents('.form-group');
//                     var $options = $.extend(true, {
//                         required: false,
//                         length: 0,
//                         custom: false
//                     }, $section[y]);

//                     //console.log('Validating sub-section: ', y, ' : ', $value);

//                     if (!$value && !$options.required) {
//                         $group.removeClass('has-error has-warning');
//                         continue;
//                     }

//                     var $error = false;

//                     if (!$value) {
//                         $error = true;
//                     }

//                     if ($options.length) {
//                         if (typeof $options.length === "number") {
//                             $options.length = [0, $options.length];
//                         }

//                         if ($value.length < $options.length[0] || $value.length > $options.length[1]) {
//                             $error = true;
//                         }
//                     }

//                     if ($options.custom) {
//                         if (!$options.custom($value)) {
//                             $error = true;
//                         }
//                     }

//                     if ($error) {
//                         $group.addClass('has-error');
//                     } else {
//                         $group.removeClass('has-error has-warning');
//                     }

//                     $valid &= !$error;
//                 }
//             }

//             if (this.isValid())
//             {
//                 if (!$valid) {
//                     Queue.addItem({
//                         type: 3,
//                         message: 'Please complete all mandatory fields'
//                     });
//                     $('#submitIdVerification').prop('disabled', true);
//                     return;
//                 }

//                 Queue.addItem({
//                     type: 1,
//                     message: 'ID verification can be submitted'
//                 });
//                 $('#submitIdVerification').prop('disabled', false);
//             }
//             else
//             {
//                 $basic.getErrors().forEach(function($error) {
//                     Queue.addItem({
//                         type: 3,
//                         message: $error
//                     });
//                 });
//                 $('#submitIdVerification').prop('disabled', true);
//             }
//         });


//         $('[data-page="basic-identification-verify"] input[type="radio"]').click(function() {
//             $basic.setDocuments($('[data-page="basic-identification-verify"] input[type="radio"][value="1"]:checked').length);
//         });

//         $('#driving-licence-country').change(function() {
//             if ($(this).val() !== 'United Kingdom') {
//                 notie.hide();
//             }
//             $('#driving-licence-number').trigger('keyup');
//         });

//         //$('#driving-licence-number').keyup(function() {
//         //
//         //    var $country = $('#driving-licence-country').val();
//         //
//         //    if ($country !== 'GB')
//         //    {
//         //        $(this).parents('.form-group').removeClass('has-error');
//         //        return;
//         //    }
//         //
//         //    $licence.setNumber($(this).val());
//         //    $basic.triggerValidation();
//         //});

//         $('#currentAddressChecked').click(function() {
//             //$basic.hasCurrentAddressInDocuments($(this).is(':checked'));
//         });

//         $('#verificationConfirmation').click(function() {
//             //$basic.hasConfirmation($(this).is(':checked'));
//         });

//         $('#submitIdVerification').click(function(e) {

//             e.preventDefault();

//             Queue.addItem({
//                 type: 2,
//                 message: 'Submitting...'
//             });

//             var $currentAddress = $basic.currentAddressChecked();
//             var $confirmation = $basic.confirmed();

//             //if (!$currentAddress || !$confirmation) {
//             //    return;
//             //}

//             var $form = $(this).parents('form');
//             $form.addClass('disave');

//             var $formData = $form.serializeArray();
//             var $data = {};

//             for (var x in $formData) {
//                 if ($formData[x].name.indexOf('identity[') === 0) {
//                     if ($formData[x].value <= 0) {
//                         continue;
//                     }
//                     var $name = $formData[x].name.substr(9, $formData[x].name.length - 10);
//                     $data[$name] = {
//                         _:'_'
//                     };
//                 } else {
//                     var $name = $formData[x].name.substr(0, $formData[x].name.indexOf('['));
//                     var $subName = $formData[x].name.substr($name.length + 1, $formData[x].name.length - ($name.length + 2));
//                     if (typeof $data[$name] !== 'undefined') {
//                         $data[$name][$subName] = $formData[x].value;
//                     }
//                 }
//             }

//             $data.confirmation = {
//                 current_address_checked: $('[name="confirmation[current_address_checked]"]').is(':checked'),
//                 confirmation: $('[name="confirmation[confirmation]"]').is(':checked')
//             }

//             $.ajax({
//                 url: $form.attr('action'),
//                 method: $form.attr('method'),
//                 data: {
//                     data: $data,
//                     fields: $form.serializeArray(),
//                     _model: $form.find('[name="_model"]').val()
//                 },
//                 dataType: 'json',
//                 success: function($json)
//                 {

//                     // Reset errors
//                     $('div.form-group.error').remove();

//                     if ($json.success)
//                     {
//                         Queue.addItem({
//                             type: 1,
//                             message: 'Identification successfully verified. Redirecting...'
//                         });

//                         window.location = '/identification/success/'+$json.id;
//                     }
//                     else
//                     {
//                         Queue.hide();
//                         $form.removeClass('disave');

//                         var $verificationPanelBody = $('div#verification-panel > div.panel-body');
//                         var formGroup = $('<div class="form-group error">');
//                         var col = $("<div class='col-sm-12'>");
//                         var alertDiv = $('<div class="alert alert-danger">');
//                         alertDiv.append("<i class='fa fa-exclamation-circle'></i> Please check all fields are entered correctly.");
//                         col.append(alertDiv);
//                         formGroup.append(col);
//                         $verificationPanelBody.prepend(formGroup);

//                         for (var x in $json.fields) {
//                             var $element = $('[name$="[' + x + ']"');
//                             if ($element.data('toggle'))
//                             {
//                                 $element = $('[data-togglable="'+$element.data('toggle')+'"]');
//                             }

//                             if (x == "current_address_checked" || x == "confirmation")
//                             {
//                                 $element = $element.parents('.form-group');
//                             }

//                             $element.addClass('has-error');
//                             $element.attr('data-toggle=tooltip');
//                             $element.attr('data-placement=top');
//                             $element.attr('title', $json.fields[x][0]);
//                             $element.tooltip();
//                         }

//                     }
//                 }
//             });
//         });
//     })();


    /**
     * DBS Id Verification validation
     */
    (function() {

        $('[name="passport[nationality]"]').change(function() {
            $('[name="passport[passport_number]"]').attr('maxlength', $(this).val() === 'United Kingdom' ? 9 : 11);
        });

        if (!$('[data-page="dbs-identification-verify"]').length)
        {
            return;
        }

        var $route = new IdVerificationRoute();
        var $experianResult = $('[name="experian_result"]').val();
        var $setValidation = false;
        var $noGroup1 = false;

        $route.registerEvent('setExternalValidationResult', function() {

            if (!this.passedExternalValidation())
            {
                Queue.addItem({
                    type: 3,
                    message: 'ID verification failed',
                    wait: true
                });
            }
            else
            {
                Queue.addItem({
                    type: 1,
                    message: 'ID verification passed',
                    wait: true
                });
            }
        });

        if (!$('[data-group] input[type="checkbox"][value="1"]:checked').length)
        {
            $('#currentAddressChecked').prop('disabled', true);
        }

        $('[name^="passport["], [name^="driving_licence["], [name^="birth_certificate["]').on('blur change', function() {
            $route.highlightAdditionalDetails();
            $route.triggerValidation();
        });

        $route.registerEvent(['setGroups', 'triggerValidation', /*'hasCurrentAddressInDocuments', 'hasConfirmation',*/ 'triggerEvents', 'setUkOrChannelIslandsBirthCertificate'], function() {
            this.toggleExclusiveDocuments();

            if (['passed', 'failed'].indexOf($experianResult) >= 0 && !$setValidation)
            {
                $setValidation = true;
                this.setExternalValidationResultWithoutNotification($experianResult === 'passed');
            }

            $('[data-value="route-info"]').removeClass('alert-info');
            $('[data-value="route-info-text"]').hide();

            var $this = this;
            var $route = this.getRoute();
            var $valid = this.isValidRoute();
            var $errorMessages = this.getInvalidGroupErrors();
            var $errorsElement = $('[data-value="route-errors"]');
            var $passedCheckboxLimit = false;

            var $currentRoute = $route.toString() + ':' + $valid.toString() + ':' + $errorMessages.join(' ');

            var $group1 = $('[data-group="group-1"] input[type="checkbox"][value="1"]:checked').length;
            var $group2a = $('[data-group="group-2a"] input[type="checkbox"][value="1"]:checked').length;
            var $group2b = $('[data-group="group-2b"] input[type="checkbox"][value="1"]:checked').length;
            var $groupTotal = $group1 + $group2a + $group2b;


            $('[data-group] input[type="checkbox"][value="1"]:not(:checked)').prop('disabled', $groupTotal >= ($route === 3 ? 5 : 3));

            if ($groupTotal >= ($route === 3 ? 5 : 3)) {
                $passedCheckboxLimit = true;
            } else {
                switch ($route) {
                    case 2:
                        $('[data-group="group-2b"] input[type="checkbox"][value="1"]:not(:checked)').prop('disabled', $group2b >= 2);
                        break;

                    case 3:
                        $('[data-group="group-2b"] input[type="checkbox"][value="1"]:not(:checked)').prop('disabled', $group2b >= 3);
                        break;
                }
            }


            if ($group1 > 0 || $noGroup1)
            {
                if ($noGroup1)
                {
                    $('[data-group]:not([data-group="group-1"])').slideDown();
                }
                else
                {
                    $('[data-group]').slideDown();
                }
                $noGroup1 = false;
                $('#applicantHasNoGroup1').prop('disabled', true);
            }
            else if ($groupTotal === 0 && $route != 2 && (!this.hadExternalValidation() || this.passedExternalValidation()))
            {
                $('[data-group]').not('[data-group="group-1"]').slideUp();
            }

            if ($route === 0)
            {
                $('[data-value="route-info"]').removeClass('alert-warning alert-danger').addClass('alert-info');
                $('[data-value="route-info-text"]').show();
                $('[data-value="route-valid"], [data-value="route"], [data-value="route-errors"]').text('');
                Queue.addItem({
                    type: 2,
                    message: 'Applicant is not part of any route. Please select documents below.'
                });

                $('#currentAddressChecked').prop('checked', false).prop('disabled', true);
                $('#verificationConfirmation').prop('checked', false).prop('disabled', true);
                //$('#applicantHasNoGroup1').prop('disabled', false);
                return;
            }

            $('#currentAddressChecked').prop('disabled', false);
            $('#verificationConfirmation').prop('disabled', false);

            if ($route === 1)
            {
                $('#applicantHasNoGroup1').prop('disabled', false);
            }

            if ($route === 2 && $valid && !this.hadExternalValidation())
            {
                $errorsElement.addClass('hidden');
            }

            if ($route === 2)
            {
                $('#verifyIdentityExternally').removeClass('hidden');
                $('#experianInstructions').removeClass('hidden');
            }
            else
            {
                $('#verifyIdentityExternally').addClass('hidden');
                $('#experianInstructions').addClass('hidden');
            }

            if ($route === 2 || $route === 3)
            {
                $('#verifyIdentityManuallyBox').removeClass('hidden');
            }
            else
            {
                $('#verifyIdentityManuallyBox').addClass('hidden');
            }

            var $disableOptions = $('[data-group^="group-2"] input[type="checkbox"]:not(:checked):not(#birth-certificate-after-birth)');
            if ($route === 3)
            {
                var $route3GroupTotal = $group2a + $group2b;
                var $conditionMet = false;

                if (!this.hasUkOrChannelIslandsBirthCertificate())
                {
                    if ($route3GroupTotal == 4) {
                        $disableOptions.prop('disabled', true);
                        $conditionMet = true;
                    }

                    $('#birth-certificate-after-birth').parents('label').addClass('text-danger');
                }
                else
                {
                    $('#birth-certificate-after-birth').parents('label').removeClass('text-danger');
                }

                if (!$conditionMet) {
                    $disableOptions.prop('disabled', false);
                }

                if ($route3GroupTotal >= 5) {
                    $('[data-group^="group-2"] input[type="checkbox"]:not(:checked)').prop('disabled', true);
                }
            }
            else
            {
                $('#birth-certificate-after-birth').parents('label').removeClass('text-danger');
                $disableOptions.prop('disabled', false);
            }

            //if (($route === 3 && $groupTotal >= 5) || ($route !== 3 && $groupTotal >= 3))
            //{
            //    $('[data-group] input[type="checkbox"]:not(:checked)').prop('disabled', true);
            //}
            //else
            //{
            //    $('[data-group] input[type="checkbox"]:disabled').prop('disabled', false);
            //}

            $('[data-value="route"]').text('This applicant is currently in route ' + $route + '.');
            $('[data-value="route-valid"]').text('This route is currently ' + ($valid ? 'valid' : 'invalid') + '.');

            if (!$passedCheckboxLimit) {
                this.toggleExclusiveDocuments();
            }

            if ($valid && $route > 1 && !this.hadExternalValidation())
            {
                $valid = false;
                $errorMessages = [
                    'External validation must be undertaken before the verification can be submitted.'
                ];
            }

            /*
            if ($valid && !$this.currentAddressChecked() && $route !== 0)
            {
                $valid = false;
                $errorMessages = [
                    'Please verify that you have checked current address, date of birth, name and address history'
                ];
            }

            if ($valid && !$this.confirmed())
            {
                $valid = false;
                $errorMessages = [
                    'Please confirm that the information provided is complete and true'
                ];
            }
            */
            if ($valid)
            {
                $('[data-value="route-info"]').addClass('alert-success').removeClass('alert-danger');

                var $skip = false;

                if ($route === 2)
                {
                    //if (!$this.hadExternalValidation())
                    //{
                    //    Queue.addItem({
                    //        type: 4,
                    //        message: 'Ready for external ID verification'
                    //    });
                    //
                    //    $skip = true;
                    //}
                    //else if ($this.passedExternalValidation())
                    //{
                    //    Queue.addItem({
                    //        type: 1,
                    //        message: 'ID verification passed',
                    //        wait: true
                    //    });
                    //}
                }

                if ($skip)
                {
                    return;
                }

                Queue.addItem({
                    type: 1,
                    message: 'Route ' + $route + ' for applicant has been completed'
                });

                $('#submitIdVerification').prop('disabled', false);

                $errorsElement.addClass('hidden').html('');
            }
            else
            {

                $('#submitIdVerification').prop('disabled', true);
                $('[data-value="route-info"]').addClass('alert-danger').removeClass('alert-success');

                $errorsElement.removeClass('hidden').html(
                    '<br>' + $errorMessages.join('<br>')
                );

                Queue.addItem({
                    type: 2,
                    message: 'The applicant is currently in route ' + $route + '<br>' + $errorMessages.join(' ')
                });
            }
        });

        $('#driving-licence, #driving-licence-outside-eu, #driving-licence-paper').change(function() {
            if ($(this).is(':not(:disabled)') && $(this).prop('checked'))
            {
                Queue.hide();
                // $('[data-role="identity-hint"]').popover('hide');
                $('#driving-licence-info-modal').modal('show');
            }
        });

        $('#submitIdVerification').click(function(e) {

            e.preventDefault();

            var $currentAddress = $route.hasCurrentAddressInDocuments();
            var $confirmation = $route.hasConfirmation();

            if (!$currentAddress || !$confirmation) {

                return;
            }

            var $form = $(this).parents('form');
            $form.addClass('disave');

            var $data = {
                group1: [],
                group2A: [],
                group2B: [],
                hadExternalValidation: $route.hadExternalValidation(),
                passedExternalValidation: $route.passedExternalValidation(),
                route: $route.getRoute(),
                confirmation : ($('#verificationConfirmation').is(':checked')) ? true : false,
                current_address_checked : ($('#currentAddressChecked').is(':checked')) ? true : false
            };

            $('input[name="group-1"]:checked').each(function() {
                $data.group1.push($(this).attr('id'));
            });

            $('input[name="group-2a"]:checked').each(function() {
                $data.group2A.push($(this).attr('id'));
            });

            $('input[name="group-2b"]:checked').each(function() {
                $data.group2B.push($(this).attr('id'));
            });

            $.ajax({
                url: $form.attr('action'),
                method: $form.attr('method'),
                data: {
                    data: $data,
                    fields: $form.serializeArray(),
                    _model: $form.find('[name="_model"]').val()
                },
                dataType: 'json',
                success: function($json)
                {

                    // Reset errors
                    $('div.form-group.error').remove();

                    if ($json.success)
                    {
                        Queue.addItem({
                            type: 1,
                            message: 'Identification successfully verified. Redirecting...'
                        });

                        window.location = '/identification/success/'+$json.id;
                    }
                    else
                    {
                        $form.removeClass('disave');
                        notie.hide();

                        var $verificationPanelBody = $('div#verification-panel > div.panel-body');
                        var formGroup = $('<div class="form-group error">');
                        var col = $("<div class='col-sm-12'>");
                        var alertDiv = $('<div class="alert alert-danger">');
                        alertDiv.append("<i class='fa fa-exclamation-circle'></i> Please check all fields are entered correctly.");
                        col.append(alertDiv);
                        formGroup.append(col);
                        $verificationPanelBody.prepend(formGroup);

                        $.each($json.errors, function(i, message) {
                            //console.log('Processing error',i,message);
                            var $element = $('[name$="[' + i + ']"');
                            var $parent = $element.parents('.form-group');
                            $parent.addClass('has-error');
                            $parent.attr('data-toggle=tooltip');
                            $parent.attr('data-placement=top');
                            $parent.attr('title', message);
                            $parent.tooltip();
                        });
                    }
                }
            });
        });

        $('[data-role="identity-hint"]').click(function(e) {
            // $('[data-role="identity-hint"]').not(this).popover('hide');
            e.preventDefault();
        });

        $('[data-group] input[type="checkbox"]').click(function() {
            $group1 = $('[data-group="group-1"] input[type="checkbox"][value="1"]:checked').length;
            $group2a = $('[data-group="group-2a"] input[type="checkbox"][value="1"]:checked').length;
            $group2b = $('[data-group="group-2b"] input[type="checkbox"][value="1"]:checked').length;
            $route.setGroups($group1, $group2a, $group2b);
        });

        $('#currentAddressChecked').click(function() {
            $route.hasCurrentAddressInDocuments($(this).is(':checked'));
        });

        $('#verificationConfirmation').click(function() {
            $route.hasConfirmation($(this).is(':checked'));
        });

        var $verificationTimeout = null;

        $('#verifyIdentityManually').change(function() {
            var $result = $(this).val();

            if (['passed', 'failed'].indexOf($result) < 0)
            {
                $route.undoExternalValidation();
                $route.triggerEvents();
                $('#id-verification-failed').show();
                $('#id-verification-failed').hide();
                return;
            }

            var $passed = $result === 'passed';

            if ($passed)
            {
                $('#id-verification-passed').show();
                $('#id-verification-failed').hide();
            }
            else
            {
                $('#id-verification-failed').show();
                $('#id-verification-passed').hide();
            }


            $route.setExternalValidationResult($passed);
            $route.triggerEvents();
        });

        $('#verifyIdentityExternally').click(function(e) {
            e.preventDefault();
            e.stopImmediatePropagation();

            $('#verifier-form').addClass('disave');

            var previousMessage = Queue.getPrevious();

            Queue.addItem({
                type:4,
                message:'Verifying id...'
            });

            var applicationId = $(this).data("applicationId");

            //add a spinner to the button
            $('#verifyIdentityExternally').attr("data-old-value", $('#verifyIdentityExternally').html());
            $('#verifyIdentityExternally').html('<i class="fa fa-refresh"></i>Communicating with Experian...');

            function addExperianErrorMessage(message) {
                removeExperianErrorMessage();
                var messageDiv = "<div data-role='experian-error' class='panel panel-danger'>"+
                                 "  <div class='panel-body'>"+message+"</div>"+
                                 "</div>";
                $(messageDiv).insertBefore($('#verifyIdentityExternally'));
            }

            function removeExperianErrorMessage() {
                $('[data-role="experian-error"]').remove();
            }

            $.ajax({
                url:'/identification/experian-verify',
                dataType: 'json',
                type: 'post',
                data : {
                    "applicationId" : applicationId
                },
                success: function($json) {
                    var $passed = $json.status;

                    if (""==$json.decision || undefined==$json.decision || ""!=$json.error) {

                        $route.undoExternalValidation();
                        $('#verifier-form').removeClass('disave');
                        addExperianErrorMessage("An error occurred whilst communicating with Experian - please try again or contact us if the error persists");
                        $('#verifyIdentityExternally').html($('#verifyIdentityExternally').attr("data-old-value"));
                        Queue.addItem(previousMessage);
                    } else {    
                        removeExperianErrorMessage();
                        $route.setExternalValidationResult($passed);
                        $('#verifier-form').removeClass('disave');
                        $('#verifyIdentityExternally').hide();
                        $('#verifyIdentityExternally').html($('#verifyIdentityExternally').attr("data-old-value"));

                        $route.triggerEvents();

                        if ($passed)
                        {
                            $('#id-verification-passed').show();
                        }
                        else
                        {
                            $('#id-verification-failed').show();
                        }

                    }
                }
            });

    
        });

        $('#birth-certificate-after-birth').click(function() {
            $route.setUkOrChannelIslandsBirthCertificate($(this).is(':checked'));
        });

        $('#applicantHasNoGroup1').click(function() {
            $('#currentAddressChecked').prop('checked', false);
            $('#verificationConfirmation').prop('checked', false);
            $('[data-group="group-1"] input:checked').prop('checked', false);
            $('[data-group="group-1"] [data-togglable]').slideUp();
            $('[data-group="group-1"]').slideUp();
            $route.setNoGroup1(true);
            $noGroup1 = true;
            $route.setGroups(0, 0, 0);
            $(this).hide();
            $('#applicantHasGroup1').show();
        });

        $('#applicantHasGroup1').click(function() {
            $('#currentAddressChecked').prop('checked', false);
            $('#verificationConfirmation').prop('checked', false);
            $('[data-group="group-1"]').slideDown();
            $('[data-group] input:checked').trigger('click');
            $route.setNoGroup1(false);
            $noGroup1 = false;
            $route.setGroups(0,0,0);
            $('[data-group]:not([data-group="group-1"])').slideUp();
            $(this).hide();
            $('#applicantHasNoGroup1').show();
        });
    })();

    /*
        Recruitment decision popup
     */
    (function() {

        var $modal = $('#recdec-modal');
        var $manager;
        var $decision;
        var $applicationId;
        var $ajax;
        var $managerInput = $('[name="recruitment_decision_manager"]', $modal);

        var openModal = function() {
            $modal.modal('show');
        };

        var closeModal = function() {
            $modal.modal('hide').on('hidden.bs.modal', removeAlert);
        }

        var removeAlert = function() {
            $('.alert', $modal).remove();
        }

        var showError = function($err) {
            if (!$('.alert', $modal).length) {
                var div = $('<div>').append('<p class="alert alert-danger text-center">'+$err+'</p>');
                $('.modal-body', $modal).append(div);
            }
        }

        $(document).on('change', '[data-role="recruitment-decision-popup"]', function() {

            $manager = $(this).data('manager');
            $managerInput.val($manager);
            $decision = $('option:selected', $(this)).val();
            $applicationId = $(this).data('applicationid');
            $ajax = $(this).data('ajax') !== undefined;
            openModal();
        });

        $('.cancel', $modal).click(function() {
            closeModal();
        });

        $('button', $modal).on('click', function(e) {
            e.preventDefault();

            var manager = $managerInput.val();

            if (manager === "") {
                return showError("Please enter a manager.");
            }

            if ($ajax)
            {
                var $data  = {
                    recruitment_decision : $decision,
                    recruitment_decision_manager : manager
                };

                $.ajax({
                    url : '/ebulk/recruitment-decision/'+$applicationId,
                    data : $data,
                    dataType : 'json',
                    type : 'post',
                    success : function($r) {
                        if ($r.status == true) {
                            return closeModal();
                        }
                        showError($r.message);
                    },
                    error : function($jqXHR) {
                        showError($jqXHR.status+ ': ' +$jqXHR.statusText);
                    }
                });

            }

            return closeModal();
        });

    })();

    (function() {
        $('table.link_editor tbody').sortable({
            connectWith : 'table.link_editor tbody',
            axis: "y",
            items: 'tr',
            placeholder : 'ui-state-highlight alert alert-warning',
            opacity: 0.5,
            helper : function(e, el) {

                var $originals = el.children();
                var $helper = el.clone();
                $helper.children().each(function(index) {
                    // Set helper cell sizes to match the original sizes
                    $(this).width($originals.eq(index).outerWidth()).css({
                        background : '#efefef',
                        border : 'none'
                    });

                });
                return $helper;
            },
            update : function(e, ui) {

                var navId = $(this).data('navigation-id');
                var tenantId = $(ui.item).data('tenant');
                var data = $(this).sortable('serialize') + "&navigationId=" + encodeURIComponent(navId);

                $.ajax({
                    data : data,
                    url : '/core/registered-bodies/'+tenantId+'/navigation/reorder',
                    type : 'post',
                    success : function() {
                    }
                });
            },
            sort : function (e, ui) {

                var $this = $(this);
                var $i = 0;
                $this.find('tr:visible:not(:last-child)').each(function() {

                    if ($(this).hasClass('ui-state-highlight'))
                    {
                        //console.log(ui.placeholder.index());
                        $this.find('tr:last-child td:first-child').text(++$i);
                    }
                    else
                    {
                        $(this).find('td:first-child').text(++$i);
                    }
                });
            },
            stop : function(e, ui) {
                ui.item.find('td:first-child').text(ui.item.index() + 1);
            }
        })
    })();

    (function() {
        /**
         * Variable to hold modal
         */
        var $modal = $('#modal-link-popup');

        /**
         * Holds the id of the clicked link
         */
        var linkId;

        /**
         * Holds the id of the tenant we are editing
         */
        var tenantId;

        /**
         * Opens modal
         */
        var openModal = function () {
            $modal.modal('show');
        };

        $modal.on('hidden.bs.modal', function () {
            $('.selectize')[0].selectize.destroy();
        });

        /**
         * Closes modal and removes the selectize object
         */
        var closeModal = function () {
            $modal.modal('hide');
        }

        /**
         * Updates view after save
         */
        var updateView = function (data) {
            var row = $('[data-rowid=' + linkId + ']');
            var labelTd = row.find('td:eq(1)');
            var urlTd = row.find('td:eq(2)');
            labelTd.text(data.label);
            urlTd.text(data.url);
        }

        /**
         * Gets data and opens modal
         */
        $('[data-role="link-popup"]').on('click', function (e) {
            e.preventDefault();

            var $this = $(this);
            var form = $('#link-edit');
            linkId = $this.data('id');
            tenantId = $this.data('tenant');

            //var promise = $.get('/navigation/link/' + linkId, function () {
            var promise = $.get('/core/registered-bodies/'+tenantId+'/navigation/' + linkId, function () {
            }, 'json');

            $.when(promise).done(function (data) {

                $.each(data, function (key, value) {
                    var control = $('[name=' + key + ']', form);

                    if (control.length > 0 && control[0].nodeName.toLowerCase() == "input") {
                        switch (control.attr("type")) {

                            case "text" :
                            case "hidden":
                                control.val(value);
                                break;
                            case "radio" :
                            case "checkbox":
                                control.each(function () {
                                    if ($(this).attr('value') == value) {
                                        $(this).attr("checked", value);
                                    }
                                });
                                break;
                            default:
                                control.val(value);
                        }
                    }


                });

                $('[name="state"] option', $modal).filter(function () {
                    return $(this).val() == data.state;
                }).prop('selected', true);

                $('[name="type"] option', $modal).filter(function () {
                    return $(this).val() == data.type;
                }).prop('selected', true);

                $('.selectize').selectize({
                    items: data.privileges.split(",")
                });

                openModal();

            });


        });

        /**
         * Closes modal when clicked
         */
        $('.cancel', $modal).click(function () {
            closeModal();
        });

        /**
         * Submits form via ajax
         */
        $('form', $modal).on('submit', function (e) {
            e.preventDefault();
            var $this = $(this);
            var data = {
                label: $('[name="label"]', $this).val(),
                welsh_label: $('[name="welsh_label"]', $this).val(),
                url: $('[name="url"]', $this).val(),
                privileges: (privs = $('.selectize', $this).val()) ? privs : [""],
                state: $('[name="state"]', $this).val(),
                type: $('[name="type"]', this).val()
            };

            $.ajax({
                data: data,
                url: '/core/registered-bodies/'+tenantId+'/navigation/' + linkId,
                type: 'post',
                success: function () {
                    updateView(data);
                    closeModal();
                }
            });
        });
    })();

    /**
     * Application status popup
     */
    (function() {
        $(document).on('click', '[data-role="status-popup"]',function (e) {
            e.preventDefault();
            var href = $(this).attr('href');
            var promise = $.get(href);

            $.when(promise).then(function (statusView) {
                $('body').prepend(statusView);
                var modal = $('#status-modal');
                modal.modal('show');

                $('.close-btn').on('click', function () {
                    modal.modal('hide');
                });

                modal.on('hidden.bs.modal', function () {
                    $(this).data('modal', null);
                    $('#status-modal').remove();
                });

            });

        });
    })();


    /**
     * National insurance number input masking
     *
     * Removed at Tom's request
     */
    //$('[data-nino-prefix]').mask('aa');
    //$('[data-nino-number]').mask('999999');


    /**
     * Dim error fields when "editted"
     */
    // $('body').on('click', '.form-group.has-error input, .form-group.has-error select', function() {
    //     var $this = $(this);
    //     setTimeout(function() {
    //         $this.parents('.form-group.has-error').addClass('has-warning').removeClass('has-error');
    //     }, 400);
    // });


    /**
     * Generic delete button to delete any model
     */
    $('body').on('click', '[data-delete]', function(e) {

        var $this = $(this);
        var $hash = $this.data('delete');
        var $parent = $this.data('delete-remove-parent');
        var $redirect = $this.data('delete-redirect');
        var $tenantId = '';
        if($this.data('tenant-id') != undefined){
           $tenantId =  $this.data('tenant-id');
        }
        var $password = $this.data('delete-password');

        var $modal = $('.modal[data-role="delete"]').clone();
        $modal.appendTo('body')
            .modal('show')
            .on('click', '[data-action="yes"]', function() {
                $.ajax({
                    url: '/api/delete',
                    type: 'post',
                    data: {
                        _method: 'DELETE',
                        _model: $hash,
                        tenantId: $tenantId,
                        password: $modal.find('[name="password"]').val()
                    },
                    dataType: 'json',
                    success: function($json)
                    {
                        if ($json.success)
                        {
                            if ($redirect)
                            {
                                window.location = $redirect;
                            }

                            $this.parents($parent).remove();
                            location.reload();
                        }
                        
                        $modal.find("#deleteMsg").empty().addClass("alert alert-danger").append($json.message);
                    }
                });
            })
            .on('click', '[data-action="no"]', function() {
                $modal.modal('hide');
            });

        $modal.on('hidden.bs.modal', function() {
            $modal.remove();
        });

        return false;
    });

    $(document).on('click', '[data-toggle-all]', function(e) {
        e.preventDefault();
        var $targets = $($(this).data('toggle-all'));
        var $state = $(this).data('toggle-state');
        if (['collapsed', 'expanded'].indexOf($state) < 0) {
            return;
        }
        var toggleTargets = function($state) {
            $targets.each(function() {
                var $target = $(this);
                var $targetTarget = $($target.data('target'));
                var $visible = $targetTarget.is(':visible');

                if ($state === 'collapsed') {
                    if ($visible) {
                        $target.click();
                    }
                } else {
                    if (!$visible) {
                        $target.click();
                    }
                }
            });
        };

        if ($state === 'collapsed') {
            $state = 'expanded';
            $(this).data('toggle-state', 'expanded');
            $(this).html('<i class="fa fa-minus"></i> Collapse All');
        } else {
            $state = 'collapsed';
            $(this).data('toggle-state', 'collapsed');
            $(this).html('<i class="fa fa-plus"></i> Expand All');
        }

        toggleTargets($state);

    });

    $(document).on('click', '[data-toggle-hide]', function(e) {
        e.preventDefault();

        var targets = $($(this).data('target'));
        var btn = $(this);
        var collapseAll = Boolean(btn.data('collapse-all'));

        if ( ! collapseAll) {
            $('i', this).toggleClass('fa-plus fa-minus');
        }

        targets.each(function(i, el) {

            var target = $(el);

            if (target.hasClass('display-toggle')) {
                return target.toggleClass('hidden ');
            }

            if ( ! collapseAll)
            {
                return target.slideToggle();
            }

            if (collapseAll && ! target.is(':visible'))
            {
                target.siblings('.panel-heading').find('a i').toggleClass('fa-plus fa-minus');
                return target.slideToggle();
            }

        });

    });

    /**
     * Workforce level switcher for barred services
     */

    var vulnerable_adults_disabled = false;
    var works_with_children_disabled = false;

     $('[name="workforce"]').on('change', function(e){
        var value = $(this).val(); 

        switch (value){
            case 'ADULT WORKFORCE':
                 $('[name="other[works_with_children]"][value="0"]').prop('checked', true);
                 $('[name="other[works_with_children]"]').prop('disabled', true);
                 $('[name="other[vulnerable_adults]"]').prop('disabled', false);
                 works_with_children_disabled = false;
                 vulnerable_adults_disabled = true;
            break;
            case 'CHILD WORKFORCE':
                 $('[name="other[works_with_children]"]').prop('disabled', false);
                 $('[name="other[vulnerable_adults]"][value="0"]').prop('checked', true);
                 $('[name="other[vulnerable_adults]"]').prop('disabled', true); 
                 works_with_children_disabled = true;
                 vulnerable_adults_disabled = false;
             break;
        default:
            works_with_children_disabled = false;
            vulnerable_adults_disabled   = false;
             $('[name="other[works_with_children]"]').prop('disabled', false);
             $('[name="other[vulnerable_adults]"]').prop('disabled', false);
        }

    });


    /**
     * DBS disclosure level option switcher
     */

    $('[name="other[disclosure_level]"]').change(function() { 
       
        var $value = $('[name="other[disclosure_level]"]:checked').val();

        var $options = $('[name="other[vulnerable_adults]"], [name="other[works_with_children]"], [name="other[working_at_home_address]"]');

        switch ($value)
        {   
            case 'standard':

            $options.filter(function(i, element) {

                if (element.name == 'other[vulnerable_adults]' && 
                works_with_children_disabled == true){
                    return;
                }
                
                if (element.name == 'other[works_with_children]' && 
                vulnerable_adults_disabled == true){
                    return;
                }

                $('[name="'+ element.name +'"][value="0"]').prop('checked', true)
                $('[name="'+ element.name +'"][value="1"]').prop('disabled', true)

            });

                break;

            case 'enhanced':
                $options.filter(function(i, element) {

                    if (element.name == 'other[vulnerable_adults]' && works_with_children_disabled == true){
                        $('[name="'+ element.name +'"][value="1"]').prop('disabled', true)
                        return;
                    }
    
                    if (element.name == 'other[works_with_children]' && vulnerable_adults_disabled == true){
                       $('[name="'+ element.name +'"][value="1"]').prop('disabled', true)
                        return;
                    }

                    $('[name="'+ element.name +'"][value="1"]').prop('disabled', false)
                });
    
                break;
        }
    });


    tinymce.init({
        selector: "[data-tinymce]",
        plugins: ["autoresize", "code", "lists", "link"],
        menubar: 'edit insert format tools'
    });

    $('[data-selectize-comma]').selectize({
        delimiter: ',',
        persist: false,
        createOnBlur:true,
        create: function(input) {
            return {
                value: input,
                text: input
            }
        },
        createFilter: function(input) { return input.length <= 34; }
    });

    $('[data-modal][data-hash]').click(function() {
        var $this = $(this);
        var $modal = $($this.data('modal'));
        $this.closest('tr').addClass("editing");
        $modal.find('[name="_model"]').val($this.data('hash'));
        $modal.find('[name="label"]').val($this.data('value'));
    });

    var toggleAdminFee = function()
    {
        var adminFee = $('[name="other[admin_fee]"]:checked');
        var val =  adminFee.val();
        var costCode = $('[name="other[cost_code]"]');
        var charge = $('[name="other[charge]"]');

        if (val == true)
        {
            costCode.attr('disabled', false).closest('.form-group').removeClass('hidden');
            charge.attr('disabled', false).closest('.form-group').removeClass('hidden');
        }
        else
        {
            costCode.attr('disabled', true).closest('.form-group').addClass('hidden');
            charge.attr('disabled', true).closest('.form-group').addClass('hidden');
        }
    }

    toggleAdminFee();
    $('[name="other[admin_fee]"]').on('click', toggleAdminFee);

    $('#print').on('click', function(e) {
        e.preventDefault();
        $('.idvSignature').removeClass('hidden');
        window.print();
    });


    /**
     * Sort out tabbing order
     */
    var $i = 0;
    $('[tabindex="0"]').attr('tabindex', '-1');
    var $indexes = $('[tabindex]');
    $('#prenav a').each(function() {
        $(this).attr('tabindex', ++$i);
    });
    $('#navigation a').each(function() {
        $(this).attr('tabindex', ++$i);
    });
    $indexes.each(function() {
        var $index = parseInt($(this).attr('tabindex'));
        if ($index > 0) {
            $(this).attr('tabindex', $index + $i);
        }
    });
    $('input:not([tabindex]), a:not([tabindex])').attr('tabindex', '-1');

    $(document).on('keyup', function(e)
    {
        var $focus = $(':focus');

        if (e.which === 9)  {
            var $modal = $('.modal:visible');

            if (!$modal.length) {
                return;
            }

            if (!$.contains($modal[0], $focus[0])) {
                $('[tabindex]:visible:first', $modal).trigger('focus');
            }
        }
    });

    $(document).keypress(function(e)
    {
        var $focus = $(':focus');

        if (e.which !== 13)  {
            return;
        }

        if ($focus.is('button, a, input:not([type="text"]'))  {
            $focus.trigger('click');
        }
    });

    function showingPostcodePopup(postcodeValue, countryValue, postcodeField){
        var postcodeRegEx = /^([A-Za-z][A-Ha-hJ-Yj-y]?[0-9][A-Za-z0-9]? [0-9][A-Za-z]{2}|[Gg][Ii][Rr] 0[Aa]{2})$/;
        if (postcodeRegEx.test(postcodeValue) === false && countryValue == 'GB') {
            postcodeField.show();
        } else {
            postcodeField.hide();
        }
    }

    /**
     * Add required to related postcode fields to Current Address
     */
    $(document).on('change', '[name$="[country]"]', function() {
        var $postcodeField = $('[name="' + $(this).attr('name').replace('country', 'postcode') + '"]').attr('id');

        if($(this).val() == 'GB')
        {
            $('[for="' + $postcodeField + '"]').text($('[for="' + $postcodeField + '"]').text() + " *")
        }
        else
        {
            $('[for="' + $postcodeField + '"]').text($('[for="' + $postcodeField + '"]').text().replace(" *", ""))
        }

        $('[name$="[postcode]"]').keyup(function () {
            showingPostcodePopup($('[name$="[postcode]"]').val(), $('[name$="[country]"]').val(), $('#postcodeWarning'));
        });
        showingPostcodePopup($('[name$="[postcode]"]').val(), $('[name$="[country]"]').val(), $('#postcodeWarning'));
    });

    /**
     * Add required to related postcode fields to Recipient Address as Admin
     */
    $(document).on('change', '[name$="[Recipient_country]"]', function() {
        var $postcodeField = $('[name="' + $(this).attr('name').replace('Recipient_country', 'Recipient_postcode') + '"]').attr('id');

        if($(this).val() == 'GB')
        {
            $('[for="' + $postcodeField + '"]').text($('[for="' + $postcodeField + '"]').text() + " *")
        }
        else
        {
            $('[for="' + $postcodeField + '"]').text($('[for="' + $postcodeField + '"]').text().replace(" *", ""))
        }

        $('[name$="[Recipient_postcode]"]').keyup(function () {
            showingPostcodePopup($('[name$="[Recipient_postcode]"]').val(), $('[name$="[Recipient_country]"]').val(), $('#postcodeWarningRecipient'));
        });
        showingPostcodePopup($('[name$="[Recipient_postcode]"]').val(), $('[name$="[Recipient_country]"]').val(), $('#postcodeWarningRecipient'));
    });

    /**
     * Add required to related postcode fields to Recipient Address as Applicant
     */
    $(document).on('change', 'select[name=Recipient_country]', function() {
        var $postcodeField = $('input[name=' + $(this).attr('name').replace('Recipient_country', 'Recipient_postcode') + ']').attr('id');

        if($(this).val() == 'GB')
        {
            $('[for="' + $postcodeField + '"]').text($('[for="' + $postcodeField + '"]').text() + " *")
        }
        else
        {
            $('[for="' + $postcodeField + '"]').text($('[for="' + $postcodeField + '"]').text().replace(" *", ""))
        }

        $('input[name=Recipient_postcode]').keyup(function () {
            showingPostcodePopup($('input[name=Recipient_postcode]').val(), $('select[name=Recipient_country]').val(), $('#postcodeWarningRecipient'));
        });
        showingPostcodePopup($('input[name=Recipient_postcode]').val(), $('select[name=Recipient_country]').val(), $('#postcodeWarningRecipient'));
    });

    $('[name$="[country]"]').trigger('change');
    $('[name$="[Recipient_country]"]').trigger('change');
    $('select[name=Recipient_country]').trigger('change');

    function validateTitleAndGender($title, $gender){
        var $femaleTitles = ['MRS', 'MISS', 'MS', 'BARONESS', 'DUCHESS', 'LADY', 'SISTER'];
        var $maleTitles = ['MR', 'BARON', 'DUKE', 'ESQ', 'FATHER', 'LORD', 'SIR'];
        if($.inArray($title, $femaleTitles) !== -1){
            if($gender == 'male'){
                $("#validateTitleAndGender").css("display", "block");
            } else {
                $("#validateTitleAndGender").css("display", "none");
            }
        }
        if($.inArray($title, $maleTitles) !== -1){
            if($gender == 'female'){
                $("#validateTitleAndGender").css("display", "block");
            } else {
                $("#validateTitleAndGender").css("display", "none");
            }
        }
    }
    
    $(document).on('change', '[name="applicant[title]"], [name="applicant[gender]"]', function() {
        var $atBirth = $('[for="' + $('[name="additional[surname_at_birth]"]').attr('id') + '"]');
        var $until = $('[for="' + $('[name="additional[surname_until]"]').attr('id') + '"]');
        var $title = $('[name="applicant[title]"]').val();
        var $gender = $('[name="applicant[gender]"]:checked').val();
        validateTitleAndGender($title, $gender);
        //console.log($title, $gender);

        if ($title != 'MISS' && $gender == 'female') {
            $atBirth.text($atBirth.text() + " *");
            $until.text($until.text() + " *");
        } else {
            $atBirth.text($atBirth.text().replace(" *", ""));
            $until.text($until.text().replace(" *", ""));
        }
    });

    $('[name="applicant[title]"], [name="applicant[gender]"]').trigger('change');


    /**
     * Search functionality
     */
    $('#search [name="search"]').on('change keyup', function()
    {
        var $value = $(this).val();
        var $matches = $value.match(/([^\s:]+):(("[^"]{0,}")|([^"\s]+)+)/g);

        var $usedFilters = [];


        if ($matches) {
            for (var $i = 0, $j = $matches.length; $i < $j; ++$i) {
                var $match = $matches[$i];
                var $index = $matches[$i].indexOf(':');
                var $filter = $match.substring(0, $index);
                var $data = $match.substring($index + 1);
                if ($data[0] === '"') {
                    $data = $data.substring(1, $data.length - 1);
                }
                $('#search [name="filters[' + $filter + ']"]').val($data);
                $usedFilters.push($filter);
            }
        }

        $('#search [name^="filters["]').each(function()
        {
            var $name = $(this).attr('name');
            $name = $name.substring(8, $name.length - 1);
            if ($usedFilters.indexOf($name) < 0) {
                $(this).val('');
            }
        });
    });

    $('#search [name^="filters["]').on('change keyup', function()
    {
        var $value = $(this).val();
        var $search = $('#search [name="search"]');
        var $searchValue = $search.val();
        var $name = $(this).attr('name');
        $name = $name.substring(8, $name.length - 1);

        if (/\s/.test($value)) {
            $value = '"' + $value + '"';
        }

        var $newSearchValue = $searchValue.replace(new RegExp($name + ':(("[^"]{0,}")|([^"\\s]+)+)'),
            $value.length > 0 ? $name + ':' + $value : ''
        );

        $newSearchValue = $newSearchValue.trim();

        if ($newSearchValue.indexOf($name + ':' + $value) < 0 && $value.length > 0) {
            //$newSearchValue += ' ' + $name + ':' + $value;
        }

        $search.val(
            $newSearchValue
        );
    });

    $('#clear-search-filters').click(function()
    {
        $('input, select', '#advanced-search').val('').trigger('change');
    });

    $(document).on('click', '#toggle-advanced-search', function()
    {
        $('#advanced-search').slideToggle();
        $(this).find('i').toggleClass('fa-plus').toggleClass('fa-minus');
    });

    $('#advanced-search').submit(function(e)
    {
        e.preventDefault();
        $('#search form:first').submit();
    });

    var checkboxes = $('.checkboxes').find(':checkbox');
    $('[data-checkbox-toggle]').on('click', function(e)
    {
        e.preventDefault();

        var checked = $(this).data('role') == "select-all" ? true : false;

        checkboxes.each(function(i, v){
            $(v).prop('checked', checked);
        });

    });

    $('button.disabled').on('click', function(e) {
        e.preventDefault();
    });

    $('body').on('click', '[data-check]', function(e) {
        e.preventDefault();
        $($(this).data('check')).prop('checked', true);
    });

    $('body').on('keydown', 'div.btn:focus', function(e) {
        if (e.which == 13) {
            $(this).trigger('click');
        }
    });

    $('body').on('click', '[data-check-all]', function() {

            var checked = $(this).is(':checked');

            if ($(this).data('targets') === undefined || $(this).data('targets') === "")
            {
                //console.log("Targets data tag is empty or could not be found.");
                return false;
            }

            $($(this).data('targets')).prop('checked', checked);
    });


    /**
     * Master binder test
     */
    window.Toggle = function($element, $properties)
    {
        if (!$properties.selector) {
            return;
        }

        var $subCheckboxes = $($properties.selector);

        this.click = function() {
            var $checked = $element.prop('checked');

            if ($checked) {
                $subCheckboxes.filter(':not(:checked)').trigger('click');
            } else {
                $subCheckboxes.filter(':checked').trigger('click');
            }

            $subCheckboxes.prop('checked', $checked);
        };
    };

    window.registerElementEvents = function() {

        $('[data-on]').each(function() {
            var $this = $(this);

            if ($this.data('__instance')) {
                return;
            }

            $this.on($this.data('on'), function(event) {
                if (!$this.data('__instance')) {
                    $this.data('__instance', new window[$this.data('instance')]($this, $this.data()));
                }
                var $instance = $this.data('__instance');
                $instance[event.type]();
            });
        });
    };

    window.registerElementEvents();

    $(document).on('elementAdded.ic', function() {
        window.registerElementEvents();
    });

    // <a href="" data-on="click" data-instance="Toggle" data-selector="">
    

    $('[data-filter]').on('keydown keyup keypress', function() {
        var $filterBy = $(this).val();
        $($(this).data('filter')).each(function() {
            var $this = $(this);
            if ($this.text().toLowerCase().indexOf($filterBy.toLowerCase()) >= 0) {
                $this.show();
            } else {
                $this.hide();
            }
        });
    });

    $(document).on('click', '[data-form-submit]', function() {
        $(document).trigger('form:submit');
        $($(this).data('form-submit')).submit();
    });

    /**
     * Driving licence length
     */
    $('[name="driving_licence[driving_licence_country]"]').change(function() {
        $('[name="driving_licence[driving_licence_number]"]').attr('maxlength', $(this).val() == 'United Kingdom' ? 18 : 20);
    });


    /**
     * Middlenames separator code
     */
    $('[name^="applicant[middle_name_"]').on('keydown', function(e) {
        if (e.keyCode === 32) {
            e.preventDefault();
        }
    });


    $('[data-role="basic-identification-continue"]').on('submit', function(e) {

        var drivingLicenseEnabled = $("input[name='identity[driving_licence]']:checked").val() == "1";
        var country = $("[name='driving_licence[driving_licence_country]']").val();

        var submitable = (function() {

            if ( ! drivingLicenseEnabled || country !== "United Kingdom")
            {
                return true;
            }

            var dl = $('#driving-licence-number').val();

            var $driver = {
                names: JSON.parse($('#driver-names').val()),
                surname: $('#driver-surname').val(),
                dob: new Date($('#driver-dob').val()),
                gender: $('#driver-gender').val()
            };

            var $licence = new UkDrivingLicence();
            $licence.setForenames($driver.names);
            $licence.setSurname($driver.surname);
            $licence.setDateOfBirth($driver.dob);
            $licence.setGender($driver.gender);
            $licence.setNumber(dl);
            $licence.setFirstName($driver.firstName);
            $licence.setMiddleName($driver.middleName);
            var $valid = $licence.isValid();
            if (!$valid) {

                $('.dl-errors #errors').html($licence.getErrors().map(function(err, i) {
                     return "<p>" + err + "</p>";
                }));

                alert("Driving license field contains errors");

                $('.dl-errors').removeClass('hidden');

            }
            return $valid;
        })();

        return submitable;
    });

    initConfirmActions();
    initTriggerPointWarnings();


    // Bind Actions Toggle Event to .table (Covers data tables)
    $('.table').on( 'draw.dt', function () {
        $('.collapser').bind('click', function() {
            $(this).next().collapse('toggle');
        });
    } );

    
});